"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenu = exports.Menu = void 0;
var Menu_1 = require("./Menu");
Object.defineProperty(exports, "Menu", { enumerable: true, get: function () { return Menu_1.Menu; } });
var SubMenu_1 = require("./SubMenu");
Object.defineProperty(exports, "SubMenu", { enumerable: true, get: function () { return SubMenu_1.SubMenu; } });
//# sourceMappingURL=index.js.map